export default __webpack_public_path__ + "static/media/Ankle.0840d573.png";